import {
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";
import React, { useRef, useState } from "react";
import { ReactComponent as CitationDevice } from "../../Assets/Svg/CitationDevice.svg";
import { ReactComponent as CitationExternal } from "../../Assets/Svg/CitationExternal.svg";
import { ReactComponent as CitationLibrary } from "../../Assets/Svg/CitationLibrary.svg";
import CitationPopup from "../Popup/CitationPopup";
import SelectCitationFromMotionList from "../Popup/SelectCitationFromMotionList";
import SelectFromLibraryPopup from "../Popup/SelectFromLibraryPopup";
import ImageCropperSRP from "./ImageCropperSRP";
import { usePlan } from "../../Context/PlanContext";

const CitationComponent = ({
  MenuHandlerComponent,
  heading = "Add citation",
  handleCitationSubmit = async () => {
    // console.log("Citation Submitted");
  },
  isLoadingFromHandleSubmit,
  from = ["gallary", "device", "external"],
  query,
  menuRef,
}) => {
  const [selectedCitation, setSelectedCitation] = useState({
    citationUrl: "",
    citationNote: "",
    citationType: "",
    citationFile: null,
    citationTitle: "",
  });
  const inputRef = useRef(null);
  const [citationPopup, setCitationPopup] = useState(false);
  const [isFromExternal, setIsFromExternal] = useState(false);
  const [imageCropperPopup, setImageCropperPopup] = useState(false);
  const [selectFromLibraryPopup, setSelectFromLibraryPopup] = useState(false);
  const [selectFromMotionList, setSelectFromMotionList] = useState(false);
  const { currentPlan } = usePlan();

  const restrictOnType = (type) => {
    let allowedTypes = [];
    if (type.includes("video")) {
      allowedTypes.push("video/mp4");
    }
    if (type.includes("doc")) {
      allowedTypes.push(".doc,.docx");
    }

    if (type.includes("pdf")) {
      allowedTypes.push(".pdf");
    }

    return allowedTypes?.length && allowedTypes.join(",");
  };

  const removeAccess = () => {
    let newFrom = [...from];
    if (!hasGallaryAccess && !hasExternalLinkAccess) {
      return newFrom?.filter((item) => item !== "gallary" && item !== "external");
    }
    if (!hasGallaryAccess) {
      newFrom = newFrom?.filter((item) => item !== "gallary");
    }
    if (!hasExternalLinkAccess) {
      newFrom = newFrom?.filter((item) => item !== "external");
    }
    return newFrom;
  }

  const allowedTypes = restrictOnType(currentPlan?.storageOption);
  const hasGallaryAccess = currentPlan?.storageOption?.includes("image");
  const hasExternalLinkAccess = currentPlan?.storageOption?.includes("links");
  const accessTypes = removeAccess();

  const Options = [
    {
      id: 1,
      SVG: CitationLibrary,
      label: "Add From Motion List",
      value: "addFromMotionList",
      tag: "motion",
      handleClick: () => {
        setSelectFromMotionList(true);
      },
    },
    {
      id: 2,
      SVG: CitationLibrary,
      label: "Add From Your Library",
      value: "addFromLibrary",
      tag: "library",
      handleClick: () => {
        setSelectFromLibraryPopup(true);
      },
    },
    {
      id: 3,
      SVG: CitationLibrary,
      label: `${
        heading === "Add Photo"
          ? "Add From Your Device"
          : "Add From Your Gallary"
      }`,
      value: "addFromGallary",
      tag: "gallary",

      handleClick: async () => {
        inputRef.current.click();
      },
    },
    {
      id: 4,
      SVG: CitationDevice,
      label: "Add From Your Device Source",
      value: "addFromDevice",
      tag: "device",

      handleClick: async () => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = allowedTypes; // Added image/* for all image types
        input.click();
        await new Promise((resolve) => {
          input.onchange = (e) => {
            resolve(e.target.files[0]);
            if (e.target.files[0]) {
              setSelectedCitation((prev) => ({
                ...prev,
                citationTitle: e.target.files[0].name,
                citationUrl: e.target.files[0].name,
                citationType: e.target.files[0].name.split(".")?.pop(),
                citationFile: e.target.files[0],
                citationFrom: "device",
              }));
              setCitationPopup(true);
            }
          };
        });
      },
    },
    {
      id: 5,
      SVG: CitationExternal,
      label: "Add From External Source",
      value: "addFromExternal",
      tag: "external",

      handleClick: () => {
        setSelectedCitation((prev) => ({
          ...prev,
          citationUrl: "",
          citationType: "",
          citationFile: null,
          citationFrom: "external",
          citationTitle: "",
        }));
        setCitationPopup(true);
        setIsFromExternal(true);
      },
    },
  ];

  const FilteredOptions = Options.filter((option) => accessTypes.includes(option.tag));

  return (
    <>
      <SelectCitationFromMotionList
        setCitationPopup={setCitationPopup}
        setSelectedCitation={setSelectedCitation}
        motionPopup={selectFromMotionList}
        setMotionPopup={setSelectFromMotionList}
      />
      <SelectFromLibraryPopup
        setCitationPopup={setCitationPopup}
        setSelectedCitation={setSelectedCitation}
        libraryPopup={selectFromLibraryPopup}
        setLibraryPopup={setSelectFromLibraryPopup}
        fromTO={heading}
        sortBy={query}
        handleSubmit={(citation) =>
          handleCitationSubmit({
            ...selectedCitation,
            ...citation,
          })
            .then((res) => {
              // console.log(res);
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              setCitationPopup(false);
              setIsFromExternal(false);
              setSelectedCitation({
                citationUrl: "",
                citationNote: "",
                citationType: "",
                citationFile: null,
              });
            })
        }
      />
      {citationPopup && (
        <CitationPopup
          heading={heading}
          setSelectedCitation={setSelectedCitation}
          popupOpen={citationPopup}
          selectedCitation={selectedCitation}
          setPopupOpen={(pop) => {
            setCitationPopup(pop);
            setIsFromExternal(pop);
          }}
          handleSubmit={() => {
            handleCitationSubmit(selectedCitation)
              .then((res) => {
                // console.log(res);
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                setCitationPopup(false);
                setIsFromExternal(false);
                setSelectedCitation({
                  citationUrl: "",
                  citationNote: "",
                  citationType: "",
                  citationFile: null,
                  citationTitle: ""
                });
              });
          }}
          isFromExternalCitation={isFromExternal}
          isUploadCitationPending={isLoadingFromHandleSubmit}
        />
      )}
      <ImageCropperSRP
        inputRef={inputRef}
        setModalOpen={setImageCropperPopup}
        modalOpen={imageCropperPopup}
        maxCropSize={500}
        type={`${
          heading === "Add Photo" || heading === "Add citation"
            ? "debate"
            : "avatar"
        }`}
        updateAvatar={(file, url) => {
          setSelectedCitation({
            ...selectedCitation,
            citationTitle: file.name,
            citationUrl: url,
            citationType: "image",
            citationFile: file,
            citationFrom: "gallary",
            citationNote: "",
          });
          heading !== "Add Photo"
            ? setCitationPopup(true)
            : handleCitationSubmit({
                ...selectedCitation,
                citationTitle: file.name,
                citationUrl: url,
                citationType: "image",
                citationFile: file,
                citationFrom: "gallary",
                citationNote: "",
              })
                .then((res) => {
                  // console.log(res);
                })
                .catch((err) => {
                  console.log(err);
                })
                .finally(() => {
                  setCitationPopup(false);
                  setIsFromExternal(false);
                  setSelectedCitation({
                    citationUrl: "",
                    citationNote: "",
                    citationType: "",
                    citationFile: null,
                  });
                });
        }}
        closeModal={() => setImageCropperPopup(false)}
        resetState={() => {
          setSelectedCitation({
            citationUrl: "",
            citationNote: "",
            citationType: "",
            citationTitle: "",
            citationFile: null,
          });
          setCitationPopup(false);
          setIsFromExternal(false);
        }}

        // handleCropClick={() => {
        //   setSelectedCitation({
        //     ...selectedCitation,
        //     citationUrl: selectedCitation.citationFile.name,
        //   });
        //   if (heading !== "Add Photo") {
        //     setCitationPopup(true);
        //     return;
        //   }
        //   handleCitationSubmit(selectedCitation);
        //   setCitationPopup(false);
        //   setIsFromExternal(false);
        //   setSelectedCitation({
        //     citationUrl: "",
        //     citationNote: "",
        //     citationType: "",
        //     citationFile: null,
        //   });
        // }}
      />
      <Menu ref={menuRef}>
        <MenuHandler>{MenuHandlerComponent}</MenuHandler>
        <MenuList className="min-w-40 bg-secondary text-debatePalette-main !z-10000000">
          {heading && (
            <div className="flex items-center p-1">
              <p className="text-sm w-full text-center text-debatePalette-background">
                {heading}
              </p>
            </div>
          )}
          {FilteredOptions?.length > 0 ? (
            FilteredOptions.map((option) => (
              <MenuItem
                id={`${option.id}-${option.label}`}
                key={option.id}
                className="flex items-center p-1 justify-start gap-3 min-w-40 z-0"
                onClick={option.handleClick}
              >
                {option.SVG && <option.SVG className="h-4 w-4" />}
                <p className="text-md font-semibold text-inherit py-2">
                  {option.label}
                </p>
              </MenuItem>
            ))
          ) : (
            <MenuItem>No Options</MenuItem>
          )}
        </MenuList>
      </Menu>
    </>
  );
};

export default CitationComponent;
